import { observer } from 'mobx-react-lite';
import { Container, Graphics, useApp } from '@pixi/react';

export const BlackLayer: React.FC = observer(() => {
  const { screen }: any = useApp();

  return (
    <Container {...({ name: 'BlackLayerContainer' } as any)}>
      <Graphics
        draw={(g: any) => {
          const width = screen?.width || (typeof window !== 'undefined' ? window.innerWidth : 1440);
          const height = screen?.height || (typeof window !== 'undefined' ? window.innerHeight : 860);
          g.clear();
          g.alpha = 0.7;
          g.beginFill('black');
          g.interactive = false;
          g.drawRect(0, 0, width, height);
        }}
      />
    </Container>
  );
});
